import { render, staticRenderFns } from "./DealCardExpanded.vue?vue&type=template&id=2adf2fe9&scoped=true"
import script from "./DealCardExpanded.vue?vue&type=script&lang=js"
export * from "./DealCardExpanded.vue?vue&type=script&lang=js"
import style0 from "./DealCardExpanded.vue?vue&type=style&index=0&id=2adf2fe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adf2fe9",
  null
  
)

export default component.exports